import { useMutation } from '@tanstack/react-query'
import { useApiClientProject } from '~/@api/client/useApiClientProject'
import type { IProjectAttachmentPdfDownloadRequest } from '~/@api/generated-api-types-project/Api'
import { downloadPDF } from '~/@lib/utils/files.utils'

function useProjectAttachmentDownload() {
  const client = useApiClientProject()

  const downloadFileMutation = useMutation({
    mutationFn: downloadFile,
  })

  async function downloadFile(params: IProjectAttachmentPdfDownloadRequest) {
    const { data } =
      await client.project.projectControllerDownloadAttachmentPdf(params, {
        secure: true,
      })
    downloadPDF(data.data.file, data.data.filename)
  }

  return {
    downloadFile: downloadFileMutation.mutate,
    isDownloadingFileId: downloadFileMutation.isPending
      ? (downloadFileMutation.variables?.fileId ?? null)
      : null,
    error: downloadFileMutation.error,
    handleReset: downloadFileMutation.reset,
  }
}

export { useProjectAttachmentDownload }
